export class VehicleSpecificationsPartViewModel {
  Type: string = "";
  StateNumber: string = "";
  VinNumber: string = "";
  ModelName: string = "";
  BrandName: string = "";
  Year: string = "";
  Color: string = "";
  FuelType: string = "";
  EngineV: number = 0;
  EngineP: number = 0;

  init(data?: any) {
    if (data) {
      this.Type = data["type"];
      this.StateNumber = data["stateNumber"];
      this.VinNumber = data["vinNumber"];
      this.ModelName = data["modelName"];
      this.BrandName = data["brandName"];
      this.Year = data["year"];
      this.Color = data["color"];
      this.FuelType = data["fuelType"];
      this.EngineV = data["engineV"];
      this.EngineP = data["engineP"];
    }
  }

  static fromJS(data: any): VehicleSpecificationsPartViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new VehicleSpecificationsPartViewModel();
    result.init(data);
    return result;
  }
}
